import { render, staticRenderFns } from "./PagellaHelp.vue?vue&type=template&id=6be6105f&"
import script from "./PagellaHelp.vue?vue&type=script&lang=js&"
export * from "./PagellaHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports